import { UserManager, WebStorageStateStore } from 'oidc-client'
import { AUTH } from '@/config'
import { api } from '@/core/api';
import ClockService from './ClockService';

const userManager = new UserManager({
  authority: AUTH.AUTHORITY,
  automaticSilentRenew: true,
  client_id: AUTH.CLIENT_ID,
  filterProtocolClaims: true,
  post_logout_redirect_uri: AUTH.POST_LOGOUT_REDIRECT_URI,
  redirect_uri: AUTH.REDIRECT_URI,
  response_type: AUTH.RESPONSE_TYPE,
  scope: AUTH.SCOPE,
  silent_redirect_uri: AUTH.SILENT_REDIRECT_URI,
  acr_values: AUTH.ACR_VALUES,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }), 
  clockService: new ClockService(),
})

export const getUser = () => {
  return userManager.getUser()
}

export const login = () => {
  return userManager.signinRedirect()
}

export const logout = () => {
  return userManager.removeUser();
}

export const validateApplicationRole = async () => {
  return (await api.get('api/account/hasallowedrole')).data;
};

export const getAccessDeniedAuthURL = () => {
  const queryParams = {
    client_id: AUTH.CLIENT_ID,
    redirect_uri: AUTH.REDIRECT_URI,
    response_type: AUTH.RESPONSE_TYPE,
    scope: AUTH.SCOPE,
    code_challenge: process.env.VUE_APP_CODE_CHALLENGE,
    code_challenge_method: process.env.VUE_APP_CODE_CHALLENGE_METHOD,
    acr_values: process.env.VUE_APP_ACR_VALUES,
    response_mode: 'query',
  };
  const returnUrl = Object.keys(queryParams)
    .map((key) => {
      return (
        encodeURIComponent(key) + '=' + encodeURIComponent(queryParams[key])
      );
    })
    .join('&');
  const getBaseName = () => {
    const value = (AUTH.AUTHORITY.split('/')[3] ?? '').trim();
    if (value) {
      return `/${value}`;
    }
    return value;
  };
  const baseName = getBaseName();
  const encodedReturnUrl = encodeURIComponent(
    `${baseName}/connect/authorize/callback?${returnUrl}`
  );
  return `${process.env.VUE_APP_URL_AUTH}/account/withoutpermission?ReturnUrl=${encodedReturnUrl}`;
};

export const addNavToFavorites = async (navId) => {
  return (await api.post(`api/account/addtofavorites/${navId}`));
};
export const removeNavToFavorites = async (navId) => {
  return (await api.delete(`api/account/removetofavorites/${navId}`));
};
export const searchUserEmail = (params) =>
  api.get(`api/account/searchuseremail`, { params });
